import request from '../../untils/request';

export function selectList(data) {
  return request({
    url: '/communicationCard/selectList',
    method: 'get',
    params: data,
  });
}

export function save(data) {
  return request({
    url: '/communicationCard',
    method: 'post',
    data: data,
  });
}

export function detail(data) {
  return request({
    url: '/communicationCard',
    method: 'get',
    params: data,
  });
}

export function remove(param) {
  return request({
    url: '/communicationCard/' + param,
    method: 'delete',
  });
}

// 批量保存
export function NbBatchAdd(data) {
  return request({
    url: '/communicationCard/batchAdd',
    method: 'post',
    data: data,
  });
}

// 获取路径
export function getPath(data) {
  return request({
    url: '/basicExcelTemplate/getPath',
    method: 'get',
    params: data,
  });
}

// 模板下载
export function load(data) {
  return request({
    url: '/file/load',
    method: 'get',
    params: data,
    responseType: 'arraybuffer',
  });
}